import { Box, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { PieChart2 } from "../../../../components/Charts";

const AgeDemographics = ({ data }) => {
    return (
        <Box>
            <Box
                display={"flex"}
                alignItems={"center"}
                gap={0.5}
                margin={"3rem 0 0 0"}
            >
                <Typography variant="h6">Age Demographics</Typography>

                <Tooltip title={data.raw_data.description} arrow>
                    <InfoIcon fontSize="small" sx={{ margin: 0 }} />
                </Tooltip>
            </Box>
            <PieChart2
                data={data.raw_data.total_value.breakdowns[0].results.map(
                    (item) => ({
                        name: item.dimension_values[0]
                            .replace("F", "Female")
                            .replace("M", "Male")
                            .replace("U", "Others"),
                        value: item.value,
                    })
                )}
                labelKey={"name"}
                dataKey={"value"}
                title="Age Distribution"
            />
        </Box>
    );
};

export default AgeDemographics;
